import React, { useState } from 'react';
import { Section } from './ui/Section';
import { FadeIn } from './ui/FadeIn';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function FAQ() {
  const faqs = [{
    q: '¿Cuánto tardaré?',
    a: '20 min de lectura. Y aplicas el protocolo cuando lo necesites.'
  }, {
    q: '¿Sirve si crío solo/a o con poca ayuda?',
    a: 'Sí. Está pensado para escenarios de alta demanda y poco tiempo.'
  }, {
    q: '¿Es una guía de crianza?',
    a: 'No. No va de que tus hijos cambien. Va de que tú estés mejor.'
  }, {
    q: '¿Cómo lo recibo?',
    a: 'Acceso inmediato tras el pago (email + página de descarga).'
  }, {
    q: '¿Es suscripción?',
    a: 'No. Pago único.'
  }, {
    q: '¿Por qué cuesta 7€?',
    a: 'Para que puedas probarlo sin pensártelo demasiado.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <Section data-id="element-12">
      <FadeIn data-id="element-13">
        <h2 className="text-2xl md:text-3xl font-bold text-charcoal mb-8" data-id="element-14">
          Preguntas rápidas
        </h2>
      </FadeIn>

      <div className="space-y-0" data-id="element-15">
        {faqs.map((faq, index) => {
        const isOpen = openIndex === index;
        return <FadeIn key={index} delay={index * 0.05} data-id="element-16">
              <div className="border-b border-border overflow-hidden" data-id="element-17">
                <button onClick={() => toggleFaq(index)} className="w-full text-left py-5 flex justify-between items-center focus:outline-none" aria-expanded={isOpen} data-id="element-18">
                  <span className={`font-semibold text-base md:text-lg pr-8 transition-colors ${isOpen ? 'text-navy' : 'text-charcoal'}`} data-id="element-19">
                    {faq.q}
                  </span>
                  <ChevronDown className={`w-5 h-5 flex-shrink-0 transition-transform duration-300 ${isOpen ? 'text-navy rotate-180' : 'text-gray'}`} data-id="element-20" />
                </button>
                <AnimatePresence data-id="element-21">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: 'easeInOut'
              }} data-id="element-22">
                      <div className="pb-5 text-gray text-base leading-relaxed" data-id="element-23">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </FadeIn>;
      })}
      </div>
    </Section>;
}